/**
 * Estado de los modales de las páginas del feature: { open, <clave> }.
 */

/** Estado inicial de un modal cerrado que referencia un elemento bajo `clave` */
export const crearModalInicial = (clave) => ({ open: false, [clave]: null });

// Cierra conservando el elemento: durante la transición de salida el modal sigue mostrándolo
export const cerrarModal = (modal) => ({ ...modal, open: false });
